import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../StudentDashboard/Sidebar";
import Header from "../StudentDashboard/Headers";
import { API_URL } from "../../config/api";
import { Outlet } from "react-router-dom";

const Parent = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserAndCourses = async () => {
      try {
        const token = localStorage.getItem("access_token");

        if (!token) {
          console.error("No access token found");
          setLoading(false);
          return;
        }

        //  Get current user
        const currentUser = await axios.get(`${API_URL}/current_user`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const userId = currentUser?.data?.user_id;

        if (!userId) {
          console.error(" user_id missing from /current_user response");
          setLoading(false);
          return;
        }

        //  Get full profile
        const userDetailRes = await axios.get(`${API_URL}/user/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setUserData(userDetailRes?.data?.data || null);
      } catch (error) {
        console.error(" Error fetching user:", error);
        setUserData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserAndCourses();
  }, []);

  // ===========================
  // Loading UI
  // ===========================
    if (loading) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4AACC5] mx-auto"></div>
      </div>
    </div>
  );
}

  // ===========================
  // Safety UI
  // ===========================
  if (!userData) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-600">
        Unable to load user data. Please log in again.
      </div>
    );
  }

  // ===========================
  // Main Dashboard Layout
  // ===========================
  return (
    <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">

      {/* Header */}
      <div className="flex-shrink-0">
        <Header userData={userData} />
      </div>

      {/* Body Layout */}
      <div className="flex flex-1 overflow-hidden">

        {/* Sidebar */}
        <div className="w-56 bg-white border-r border-neutral-200 flex-shrink-0">
          <Sidebar />
        </div>

        {/* Page Content */}
        <div className="flex-1 p-4 overflow-y-auto">
          <Outlet context={{ userData }} />
        </div>

      </div>
    </div>
  );
};

export default Parent;
